import {
  USER_NOTIFICATION_TYPE_PARENT,
  USER_NOTIFICATION_TYPE_AUTHORIZED_PERSON,
  USER_NOTIFICATION_TYPE_BUS,
  USER_NOTIFICATION_TYPE_CANCEL,
  USER_NOTIFICATION_TYPE_PARENT_UPDATE,
  USER_NOTIFICATION_TYPE_PARENT_APPROVE,
  USER_NOTIFICATION_TYPE_APPROVE_PARENT,
  USER_NOTIFICATION_TYPE_REJECT_PARENT, USER_NOTIFICATION_TYPE_STUDENT_NEW
} from "../../../config";

export default {
  getLoginData (state, payload) {
    localStorage.setItem('token', payload.token)
    state.adminLoggedInfo = payload
    state.lang = payload.lang
  },

  logout (state) {
    localStorage.removeItem('token')
    state.adminLoggedInfo = null
  },

  startVerify (state) {
    state.isVerifying = true
  },

  endVerify (state) {
    state.isVerifying = false
  },

  verifySuccess (state, payload) {
    state.isVerifying = false
    state.adminLoggedInfo = payload
    state.lang = payload.lang

    if (payload.unread_notification_list) {
      state.unreadNotificationList.parentNotificationIds = [].concat(
        state.unreadNotificationList.parentNotificationIds,
        payload.unread_notification_list.parent_notification_ids
      )
      state.unreadNotificationList.parentUpdateHistoryIds = [].concat(
        state.unreadNotificationList.parentUpdateHistoryIds,
        payload.unread_notification_list.parent_update_history_ids
      )
      state.unreadNotificationList.busNotificationIds = [].concat(
        state.unreadNotificationList.busNotificationIds,
        payload.unread_notification_list.bus_notification_ids
      )
      state.unreadNotificationList.cancelIds = [].concat(
        state.unreadNotificationList.cancelIds,
        payload.unread_notification_list.cancel_ids
      )
      state.unreadNotificationList.authorizedPersonIds = [].concat(
        state.unreadNotificationList.authorizedPersonIds,
        payload.unread_notification_list.authorized_person_ids
      )
    }
    if(payload.approve_list){
      state.unreadNotificationList.parentApproveIds = [].concat(state.unreadNotificationList.parentApproveIds,payload.approve_list.parent_approve_ids)
    }
    if(payload.new_student_list){
      state.unreadNotificationList.newStudentNoticeIds = [].concat(state.unreadNotificationList.newStudentNoticeIds,payload.new_student_list)
    }
  },

  updateLanguage (state, payload) {
    state.lang = payload.lang
  },

  addUnreadNotification (state, { notification }) {
    switch (notification.type) {
      case USER_NOTIFICATION_TYPE_PARENT:
        state.unreadNotificationList.parentNotificationIds.unshift(notification.data.id)
        break
      case USER_NOTIFICATION_TYPE_PARENT_UPDATE:
        state.unreadNotificationList.parentUpdateHistoryIds.unshift(notification.data.id)
        break
      case USER_NOTIFICATION_TYPE_BUS:
        state.unreadNotificationList.busNotificationIds.unshift(notification.data.id)
        break
      case USER_NOTIFICATION_TYPE_CANCEL:
        state.unreadNotificationList.cancelIds.unshift(notification.data.id)
        break
      case USER_NOTIFICATION_TYPE_AUTHORIZED_PERSON:
        state.unreadNotificationList.authorizedPersonIds.unshift(notification.data.id)
        break
      case USER_NOTIFICATION_TYPE_PARENT_APPROVE:
        state.unreadNotificationList.parentApproveIds.unshift(notification.data.id)
        break
      case USER_NOTIFICATION_TYPE_STUDENT_NEW:
        state.unreadNotificationList.newStudentNoticeIds.unshift(notification.data.id)
        break
      default:
        break
    }
  },

  readNotificationListStudent(state, payload){
    if(state.unreadNotificationList.newStudentNoticeIds.length >0){
      let list = state.unreadNotificationList.newStudentNoticeIds
      let index = list.findIndex(el => el ===payload.student.id)
      if(index!== -1){
        list.splice(index,1)
      }
    }
  },

  readNotification (state, { notification }) {
    let list

    switch (notification.type) {
      case USER_NOTIFICATION_TYPE_PARENT:
        list = state.unreadNotificationList.parentNotificationIds
        break
      case USER_NOTIFICATION_TYPE_PARENT_UPDATE:
        list = state.unreadNotificationList.parentUpdateHistoryIds
        break
      case USER_NOTIFICATION_TYPE_BUS:
        list = state.unreadNotificationList.busNotificationIds
        break
      case USER_NOTIFICATION_TYPE_CANCEL:
        list = state.unreadNotificationList.cancelIds
        break
      case USER_NOTIFICATION_TYPE_AUTHORIZED_PERSON:
        list = state.unreadNotificationList.authorizedPersonIds
        break
      case USER_NOTIFICATION_TYPE_APPROVE_PARENT:
        list = state.unreadNotificationList.parentApproveIds
        break
      case USER_NOTIFICATION_TYPE_REJECT_PARENT:
        list = state.unreadNotificationList.parentApproveIds
        break
      default:
        break
    }

    if (list) {
      let index = list.indexOf(parseInt(notification.data.id))
      if (index !== -1) {
        list.splice(index, 1)
      }
    }
  }
}
